import { Grid, Typography } from '@material-ui/core'
import { a11yProps, Tab, TabPanel, Tabs } from 'asterX-UI/Tabs'
import { ropTabsList } from './constants'
import { useRopStyles } from '../../rop.styles'
import { GRAY_COLORS } from 'asterX-UI'
import moment from 'moment/moment'
import { useHomeStoreRop } from 'context/HomeStore/Rop'

export const RopTabs = () => {
  const {
    homeStore: { ropTab },
    homeStoreFunc: { setRopTab }
  } = useHomeStoreRop()

  const classes = useRopStyles()

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          style={{ borderBottom: `1px solid ${GRAY_COLORS[200]}` }}
        >
          <Grid item>
            <Tabs
              className={classes.ropTabs}
              value={ropTab}
              onChange={(e, newValue) => setRopTab(newValue)}
            >
              {ropTabsList.map((e, i) => {
                const Icon = e?.icon ? e?.icon : null
                return (
                  <Tab
                    className={classes.ropTab}
                    key={`rop-tab-${i}`}
                    label={e?.label || ''}
                    icon={Icon && <Icon />}
                    value={i}
                    {...a11yProps(i)}
                  />
                )
              })}
            </Tabs>
          </Grid>
        </Grid>

        <Grid item style={{ margin: '16px 0' }}>
          <Typography
            variant="subtitle2"
            style={{ color: GRAY_COLORS[500], textTransform: 'capitalize' }}
          >
            {moment().format('dddd, D MMMM')}
          </Typography>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        {ropTabsList.map((e, i) => {
          const Component = e.component
          return (
            <TabPanel key={`rop_tab_panel_${i}`} index={i} value={ropTab}>
              <Component />
            </TabPanel>
          )
        })}
      </Grid>
    </Grid>
  )
}
